import { createTheme, useMediaQuery } from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400
    }
  }
});

export const useMuiScreenSizes = () => {
  const isScreenSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isScreenMedium = useMediaQuery(theme.breakpoints.down("md"));
  const isScreenLarge = useMediaQuery(theme.breakpoints.down("lg"));
  const isScreenXLarge = useMediaQuery(theme.breakpoints.down("xl"));
  const isScreenXXLarge = useMediaQuery(theme.breakpoints.down("xxl"));

  return { isScreenSmall, isScreenMedium, isScreenLarge, isScreenXLarge, isScreenXXLarge };
};
